// An audience constraint's selected demographics are persisted as a plain array (matching bpm's
// original AudiencePickerModal wiring), but older/malformed records can still carry the object
// shape (`Record<string, boolean>`) this port originally (incorrectly) assumed everywhere -- accept
// either so validation and display agree regardless of which shape a given record actually has.
export const demographicKeys = (demographic?: string[] | Record<string, unknown>): string[] =>
  Array.isArray(demographic) ? demographic : Object.keys(demographic ?? {});
